module.exports = __webpack_public_path__ + "img/MicrosoftTeams-image.fe324024.png";